"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tasks = void 0;
function tasks(finished_chart, index, grammar_name) {
    const task_map = finished_chart[index].get(grammar_name);
    if (task_map !== undefined) {
        return task_map.values();
    }
    else {
        const empty_map = new Map();
        return empty_map.values();
    }
}
exports.tasks = tasks;
//# sourceMappingURL=finished-chart-tasks.js.map